import React, { useEffect, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Tooltip from '@mui/material/Tooltip';
import { DragIndicator } from '@material-ui/icons';
import { IN_ROOM_DINING_MENU_CATEGORIES } from '../../../../../constants/InRoomDiningConst';
import SubMenu from './Sub-Menu';
import { useSelector } from 'react-redux';
import {
  inRoomDiningCategorySelector,
  inRoomDiningCombosSelector,
  inRoomDiningItemsSelector,
} from '../../../servicesSlice';

const MenuAccordion = (props) => {
  const {
    onClickCategoryAccordion,
    onClickCategoryActive,
    onItemDragOver,
    onDrop,
    setCategory,
    category,
    onCategoryHover,
    onDeleteCategory,
    onAddSubCategory,
    onClickSubCategoryName,
    activeTab,
  } = props;
  const globalItems = useSelector(inRoomDiningItemsSelector);
  const globalCombos = useSelector(inRoomDiningCombosSelector);
  const globalCategories = useSelector(inRoomDiningCategorySelector);
  const [manualToggles, setManualToggles] = useState({
    categories: {},
    items: {},
  });
  const toggleCategoryActive = (e, catItem, catIndex) => {
    e?.stopPropagation();
    const reduxEntry = globalCategories?.find((g) => g?.id === catItem?.id);
    const base = reduxEntry ? reduxEntry?.status : category[catIndex]?.isActive;
    const prev = manualToggles?.categories[catItem.id] ?? base;
    const newVal = !prev;
    const directItemIds = category[catIndex]?.items?.map((it) => it?.id);
    const subItemIds = category[catIndex]?.subCategories?.flatMap((sub) =>
      sub?.items?.map((it) => it.id),
    );
    const allItemIds = [...directItemIds, ...subItemIds];
    const itemsToggleUpdates = allItemIds?.reduce((acc, id) => {
      acc[id] = newVal;
      return acc;
    }, {});
    setManualToggles((m) => ({
      categories: { ...m.categories, [catItem?.id]: newVal },
      items: { ...m.items, ...itemsToggleUpdates },
    }));
    setCategory((cats) =>
      cats?.map((c, i) =>
        i !== catIndex
          ? c
          : {
              ...c,
              isActive: newVal,
              items: c?.items?.map((it) => ({ ...it, isActive: newVal })),
              subCategories: c.subCategories?.map((sc) => ({
                ...sc,
                items: sc?.items?.map((it) => ({ ...it, isActive: newVal })),
              })),
            },
      ),
    );
    onClickCategoryActive(e, catItem, catIndex, null, null, null, 'categories');
  };
  const getEffectiveCatActive = (categoryData, globalCategories, manualToggles) => {
    const reduxEntry = globalCategories?.find((c) => c?.id === categoryData?.id);
    const base = reduxEntry ? reduxEntry?.status : categoryData?.isActive;
    const manual = manualToggles?.categories?.[categoryData?.id];
    return typeof manual === 'boolean' ? manual : !!base;
  };
  const getEffectiveItemActive = (
    categoryData,
    item,
    globalCategories,
    _globalItemsUnused,
    manualToggles,
    ignoreCategoryGate = false,
  ) => {
    const catActive = getEffectiveCatActive(categoryData, globalCategories, manualToggles);
    if (!ignoreCategoryGate && !catActive) return false;

    const manualLinkActive = manualToggles?.items?.[item?.id];
    const isCombo = globalCombos?.some((c) => c?.id === item?.id);
    if (isCombo) {
      const globalCombo = globalCombos?.find((c) => c?.id === item?.id);
      const globalActive = !!globalCombo?.status;
      const linkedActive =
        typeof manualLinkActive === 'boolean' ? manualLinkActive : !!item?.isActive;
      return globalActive && linkedActive;
    }
    if (typeof manualLinkActive === 'boolean') {
      return manualLinkActive;
    }
    const linkActive = !!item?.isActive;
    const globalActive = globalItems?.find((g) => g?.id === item?.id)?.status;
    return linkActive && globalActive;
  };
  const toggleItemActive = (e, item, catIndex, itemIndex) => {
    e?.stopPropagation();
    const currentManual = manualToggles?.items?.[item?.id];
    const currentLink =
      typeof currentManual === 'boolean'
        ? currentManual
        : !!category[catIndex]?.items?.[itemIndex]?.isActive;
    const newItemState = !currentLink;
    const updatedItemToggles = {
      ...manualToggles?.items,
      [item.id]: newItemState,
    };
    const allChildren = [
      ...(category[catIndex]?.items || []),
      ...(category[catIndex]?.subCategories || []).flatMap((sc) => sc?.items || []),
    ];
    const simulatedManual = {
      categories: manualToggles.categories,
      items: updatedItemToggles,
    };
    const newCatState = allChildren.some((child) =>
      getEffectiveItemActive(
        category[catIndex],
        child,
        globalCategories,
        globalItems,
        simulatedManual,
        true,
      ),
    );
    setManualToggles((m) => ({
      categories: {
        ...m.categories,
        [category[catIndex].id]: newCatState,
      },
      items: updatedItemToggles,
    }));

    setCategory((cats) =>
      cats?.map((c, ci) => {
        if (ci !== catIndex) return c;
        const newItems = c?.items?.map((it, ii) =>
          ii === itemIndex ? { ...it, isActive: newItemState } : it,
        );
        return {
          ...c,
          isActive: newCatState,
          items: newItems,
          subCategories: c.subCategories,
        };
      }),
    );
    onClickCategoryActive(e, item, catIndex, null, null, itemIndex, 'items');
    // onClickCategoryActive(e, category[catIndex], catIndex, null, null, null, 'categories');
  };

  useEffect(() => {
    setCategory((currentCats) =>
      currentCats?.map((cat) => {
        const gCat = globalCategories?.find((g) => g?.id === cat?.id);
        const isActiveCat = gCat ? gCat?.status : cat?.isActive;
        const items = cat?.items?.map((it) => {
          const gIt = globalItems?.find((g) => g?.id === it?.id);
          return gIt ? { ...it, isActive: gIt?.status } : it;
        });
        const subCategories = cat?.subCategories?.map((sub) => ({
          ...sub,
          items: sub?.items?.map((it) => {
            const gIt = globalItems?.find((g) => g?.id === it?.id);
            return gIt ? { ...it, isActive: gIt.status } : it;
          }),
        }));

        return { ...cat, isActive: isActiveCat, items, subCategories };
      }),
    );
  }, [globalItems, globalCategories, setCategory]);

  function handleOnDragEnd(result) {
    if (!result.destination) return;

    const items = Array.from(category);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setCategory(items);
  }
  function hanledOnItemDrag(result) {
    if (!result.destination) return;
    const categoryIndex = parseInt(result.draggableId.split('-')[0], 10); // or pass it via context/prop
    const items = Array.from(category[categoryIndex].items);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setCategory((prev) => prev.map((c, i) => (i === categoryIndex ? { ...c, items } : c)));
  }

  function hanledOnSubCategoryDrag(result) {
    if (!result.destination) return;
    const categoryIndex = parseInt(result.draggableId.split('-')[0], 10);
    const items = Array.from(category[categoryIndex].subCategories);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setCategory((prev) =>
      prev.map((c, i) => (i === categoryIndex ? { ...c, subCategories: items } : c)),
    );
  }

  const onDragScratch = (e, call, type, ndx) => {
    if (activeTab !== IN_ROOM_DINING_MENU_CATEGORIES) return false;
    if (call === 'onItemDragOver') return onItemDragOver(e);
    return onDrop(e, type, ndx, null, 'test');
  };

  const getGlobalObjectActiveById = (id) => {
    const itm = globalItems?.find((g) => g?.id === id);
    if (itm) return !!itm.status;
    const cmb = globalCombos?.find((g) => g?.id === id);
    if (cmb) return !!cmb.status;
    return false;
  };

  return (
    <div className='col-md-7 droppable mb-1'>
      <div>
        <div
          className='menu-list-box'
          onDragOver={(e) => onDragScratch(e, 'onItemDragOver')}
          onDrop={(e) => onDragScratch(e, 'onDrop', 'Categories', 0)}
        >
          <div className='scroll-section mb-4'>
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId='categories'>
                {(provided) => (
                  <div className='categories' {...provided.droppableProps} ref={provided.innerRef}>
                    {category &&
                      category.length > 0 &&
                      category.map((categoryData, categoryIndex) => (
                        <Draggable
                          key={categoryData.id}
                          draggableId={categoryData.id}
                          index={categoryIndex}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <div className='row p-1' key={categoryIndex}>
                                <div className='col-md-12'>
                                  <div
                                    className='row'
                                    onMouseOver={(e) =>
                                      onCategoryHover(e, categoryIndex, true, 'Categories')
                                    }
                                    onMouseLeave={(e) =>
                                      onCategoryHover(e, categoryIndex, false, 'Categories')
                                    }
                                  >
                                    <div
                                      className='col-md-8'
                                      onDragOver={(e) => onItemDragOver(e)}
                                      onDrop={(e) => onDrop(e, 'Categories', categoryIndex, null)}
                                    >
                                      <div className='ird-menu-accordion'>
                                        <div className='row mt-3 pb-2'>
                                          <div className='col-md-1'>
                                            <DragIndicator className='ird-menu-accordion-drag' />
                                          </div>
                                          <div className='col-md-8 ird-menu-accordion-text'>
                                            {categoryData.name}
                                          </div>
                                          {(() => {
                                            const reduxEntry = globalCategories?.find(
                                              (c) => c?.id === categoryData?.id,
                                            );
                                            const base = reduxEntry
                                              ? reduxEntry?.status
                                              : categoryData?.isActive;
                                            const manual =
                                              manualToggles?.categories[categoryData?.id];
                                            const isCatActive =
                                              typeof manual === 'boolean' ? manual : base;

                                            return (
                                              <div
                                                className='col-md-1'
                                                onClick={(e) =>
                                                  toggleCategoryActive(
                                                    e,
                                                    categoryData,
                                                    categoryIndex,
                                                  )
                                                }
                                              >
                                                <Tooltip
                                                  title={isCatActive ? 'Hide' : 'Unhide'}
                                                  placement='bottom-end'
                                                >
                                                  {isCatActive ? (
                                                    <RemoveRedEyeIcon />
                                                  ) : (
                                                    <VisibilityOffIcon />
                                                  )}
                                                </Tooltip>
                                                
                                              </div>
                                            );
                                          })()}

                                          <div
                                            className='col-md-1'
                                            onClick={(e) =>
                                              onClickCategoryAccordion(
                                                e,
                                                categoryIndex,
                                                categoryData.isExpanded,
                                                null,
                                                'category',
                                              )
                                            }
                                          >
                                            {categoryData.isExpanded ? (
                                              <ExpandLessIcon />
                                            ) : (
                                              <ExpandMoreIcon />
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {categoryData.isHovered && (
                                      <div className='col-md-2 ird-hover-popup'>
                                        <div className='row justify-content-around'>
                                          <div
                                            className='col-md-1'
                                            onClick={(e) =>
                                              onDeleteCategory(e, categoryIndex, 'categories')
                                            }
                                          >
                                            <Tooltip title='Remove' placement='bottom-end'>
                                              <DeleteForeverIcon />
                                            </Tooltip>
                                          </div>
                                          <div
                                            className='col-md-1'
                                            onClick={(e) =>
                                              onAddSubCategory(
                                                e,
                                                categoryIndex,
                                                categoryData.isExpanded,
                                              )
                                            }
                                          >
                                            <Tooltip
                                              title='Add Sub-Category'
                                              placement='bottom-end'
                                            >
                                              <AddCircleIcon />
                                            </Tooltip>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <div>
                                    <DragDropContext onDragEnd={hanledOnItemDrag}>
                                      <Droppable droppableId={`subItems-${categoryData.id}`}>
                                        {(provided) => (
                                          <div
                                            className='subItems'
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                          >
                                            {categoryData.isExpanded &&
                                              categoryData.items &&
                                              categoryData.items.length > 0 &&
                                              categoryData.items.map((items, itemNdx) => (
                                                <Draggable
                                                  key={items?.id}
                                                  draggableId={categoryIndex + '-' + items?.id}
                                                  categoryIndex={categoryIndex}
                                                  index={itemNdx}
                                                >
                                                  {(provided) => (
                                                    <div
                                                      ref={provided.innerRef}
                                                      {...provided.draggableProps}
                                                      {...provided.dragHandleProps}
                                                    >
                                                      <div
                                                        className='row p-1'
                                                        onMouseOver={(e) =>
                                                          onCategoryHover(
                                                            e,
                                                            categoryIndex,
                                                            true,
                                                            'items',
                                                            null,
                                                            itemNdx,
                                                          )
                                                        }
                                                        onMouseLeave={(e) =>
                                                          onCategoryHover(
                                                            e,
                                                            categoryIndex,
                                                            false,
                                                            'items',
                                                            null,
                                                            itemNdx,
                                                          )
                                                        }
                                                      >
                                                        <div className='col-md-8 ird-menu-accordion-items-div'>
                                                          <div className='ird-menu-accordion-items pb-3'>
                                                            <div className='row justify-content-center'>
                                                              <div className='col-md-1 mt-3'>
                                                                <DragIndicator className='ird-menu-accordion-drag' />
                                                              </div>
                                                              <div className='col-md-9 ird-menu-accordion-text mt-3'>
                                                                {items?.name}
                                                              </div>
                                                              {(() => {
                                                                const isCatActive =
                                                                  getEffectiveCatActive(
                                                                    categoryData,
                                                                    globalCategories,
                                                                    manualToggles,
                                                                  );
                                                                const isItemActive =
                                                                  getEffectiveItemActive(
                                                                    categoryData,
                                                                    items,
                                                                    globalCategories,
                                                                    globalItems,
                                                                    manualToggles,
                                                                  );

                                                                return (
                                                                  <div
                                                                    className='col-md mt-3'
                                                                    onClick={(e) =>
                                                                      toggleItemActive(
                                                                        e,
                                                                        items,
                                                                        categoryIndex,
                                                                        itemNdx,
                                                                      )
                                                                    }
                                                                  >
                                                                    <Tooltip
                                                                      title={
                                                                        isItemActive
                                                                          ? 'Hide'
                                                                          : 'Unhide'
                                                                      }
                                                                      placement='bottom-end'
                                                                    >
                                                                      {isItemActive ? (
                                                                        <RemoveRedEyeIcon />
                                                                      ) : (
                                                                        <VisibilityOffIcon />
                                                                      )}
                                                                    </Tooltip>
                                                                  </div>
                                                                );
                                                              })()}
                                                            </div>
                                                          </div>
                                                        </div>
                                                        {items.isHovered && (
                                                          <div
                                                            className='col-md-1 ird-hover-popup'
                                                            onClick={(e) =>
                                                              onDeleteCategory(
                                                                e,
                                                                categoryIndex,
                                                                'items',
                                                                null,
                                                                itemNdx,
                                                              )
                                                            }
                                                          >
                                                            <Tooltip
                                                              title='Remove'
                                                              placement='bottom-end'
                                                            >
                                                              <DeleteForeverIcon />
                                                            </Tooltip>
                                                          </div>
                                                        )}
                                                      </div>
                                                    </div>
                                                  )}
                                                </Draggable>
                                              ))}
                                            {provided.placeholder}
                                          </div>
                                        )}
                                      </Droppable>
                                    </DragDropContext>
                                  </div>
                                  <div>
                                    <DragDropContext onDragEnd={hanledOnSubCategoryDrag}>
                                      <Droppable droppableId='subCategories'>
                                        {(provided) => (
                                          <div
                                            className='subCategories'
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                          >
                                            {categoryData.isExpanded &&
                                              categoryData.subCategories &&
                                              categoryData.subCategories.length > 0 &&
                                              categoryData.subCategories.map(
                                                (subCategoriesData, subCategoriesndx) => (
                                                  <Draggable
                                                    key={subCategoriesData.id}
                                                    draggableId={
                                                      categoryIndex + '-' + subCategoriesData.id
                                                    }
                                                    index={subCategoriesndx}
                                                  >
                                                    {(provided) => (
                                                      <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                      >
                                                        <SubMenu
                                                          categoryIndex={categoryIndex}
                                                          subCategoriesndx={subCategoriesndx}
                                                          subCategoriesData={subCategoriesData}
                                                          onCategoryHover={onCategoryHover}
                                                          onItemDragOver={onItemDragOver}
                                                          onDrop={onDrop}
                                                          onClickSubCategoryName={
                                                            onClickSubCategoryName
                                                          }
                                                          onClickCategoryAccordion={
                                                            onClickCategoryAccordion
                                                          }
                                                          onDeleteCategory={onDeleteCategory}
                                                          key={subCategoriesndx}
                                                          onClickCategoryActive={
                                                            onClickCategoryActive
                                                          }
                                                          category={category}
                                                          setCategory={setCategory}
                                                        />
                                                      </div>
                                                    )}
                                                  </Draggable>
                                                ),
                                              )}
                                            {provided.placeholder}
                                          </div>
                                        )}
                                      </Droppable>
                                    </DragDropContext>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuAccordion;
